import { format, parseISO, subDays } from 'date-fns';
import { API_DATE_FORMAT } from '../../../utils';
export const subsHalfCalendarDaysCount = (segment, calendarDaysCount) => {
    const daysOffset = Math.floor(calendarDaysCount / 2);
    return Object.assign(Object.assign({}, segment), { date: format(subDays(parseISO(segment.date), daysOffset), API_DATE_FORMAT) });
};
